var map = {
	"./additional-dishes-0.jpg": 3841,
	"./additional-dishes-1.jpg": 8396,
	"./borsch.jpg": 6632,
	"./broccoli.jpg": 70,
	"./buckwheat-liver-pancakes.jpg": 896,
	"./cabbage-varenyky.jpg": 7867,
	"./cesar.jpg": 4555,
	"./chebureky.jpg": 2839,
	"./cheese-greens-chebureky.jpg": 4311,
	"./cheese-mushrooms-pancakes.jpg": 6373,
	"./cherries-varenyky.jpg": 3861,
	"./cherry-bagels.jpg": 1096,
	"./cherry-biscuit.jpg": 4345,
	"./cherry-cake.jpg": 8526,
	"./chicken-cheese-pancakes.jpg": 4730,
	"./chicken-pineapple.jpg": 5372,
	"./condensed-milk-nuts.jpg": 8237,
	"./condensed-milk-tubes.jpg": 7061,
	"./control-report.jpg": 6209,
	"./crab-sticks.jpg": 5179,
	"./curd-raisins-pancakes.jpg": 37,
	"./dishes-background.jpg": 3575,
	"./eclairs.jpg": 6098,
	"./georgian.jpg": 6354,
	"./golubci.jpg": 1649,
	"./gulyash.jpg": 6889,
	"./hanna.jpg": 1880,
	"./harcho.jpg": 4824,
	"./holiday-menu-square.jpg": 4118,
	"./holiday-menu.jpg": 8217,
	"./honey-cake.jpg": 3320,
	"./kings-menu-square.jpg": 5962,
	"./kings-menu.jpg": 3557,
	"./kirill.jpg": 9942,
	"./kotleta-po-kyivsky.jpg": 8585,
	"./main-background-0.jpg": 3083,
	"./main-background-1-mobile.jpg": 6128,
	"./main-background-1.jpg": 8135,
	"./main-background-2.jpg": 4166,
	"./main-background.jpg": 3174,
	"./medium-menu.jpg": 3217,
	"./menus-background.jpg": 6350,
	"./meringue-roll.jpg": 6894,
	"./napoleon-cake.jpg": 9212,
	"./oleksandra.jpg": 1748,
	"./olena.jpg": 8089,
	"./olivye.jpg": 4831,
	"./pelmeni.jpg": 3716,
	"./pork-pancakes.jpg": 9697,
	"./potatoes-varenyky.jpg": 923,
	"./report.jpg": 2158,
	"./salmon-soup.jpg": 2405,
	"./salty-pies.jpg": 2595,
	"./sea-soup.jpg": 4478,
	"./sea.jpg": 8562,
	"./shuba.jpg": 11,
	"./solyanka.jpg": 6674,
	"./standard-menu-square.jpg": 7918,
	"./standard-menu.jpg": 7602,
	"./start-menu.jpg": 4221,
	"./sweet-pies.jpg": 8318,
	"./tuna.jpg": 9922,
	"./valentyn.jpg": 7111
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5477;